<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav" isActive="project" />

    <div class="headerbg"><span>项目中心</span><b>PROJECT CENTER</b></div>
    <div class="main">
      <span>全球首创 自主创新</span>
      <div class="titletext">
        东云启创总共为超过 <i>100</i> 家院校机构客户和<i> 20</i>
        余个政府机构提供智能服务， 每天产生的数据调用次数超过 <i>10 </i> 万次。
      </div>
      <div class="btn-box">
        <div :class="{ active: isActive === 0 }" @click="jdxm">经典项目</div>
        <div :class="{ active: isActive === 1 }" @click="zfxm">政府项目</div>
        <div :class="{ active: isActive === 2 }" @click="gxxm">高校项目</div>
        <div :class="{ active: isActive === 3 }" @click="xmfh">项目孵化</div>
      </div>

      <div class="loop">
        <el-carousel
          :initial-index="0"
          height="763px"
          indicator-position="none"
          arrow="never"
          ref="loop"
          
          @change="changepage"
          :autoplay="false"
         
        >
          <el-carousel-item class="loop-item">
            <div v-for="item in imgList" :key="item.id" @click="handleImg(item.superLinks)">
              <img :src="item.coverImg" alt="" />
            </div>
          </el-carousel-item>
          <el-carousel-item class="loop-item">
            <div v-for="item in imgList2" :key="item.id" @click="handleImg(item.superLinks)">
              <img :src="item.coverImg" alt="" />
            </div>
          </el-carousel-item>
          <el-carousel-item class="loop-item">
            <div v-for="item in imgList3" :key="item.id" @click="handleImg(item.superLinks)">
              <img :src="item.coverImg" alt="" />
            </div>
          </el-carousel-item>
          <el-carousel-item class="loop-item">
            <div v-for="item in imgList4" :key="item.id" @click="handleImg(item.superLinks)">
              <img :src="item.coverImg" alt="" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { getImgList } from '@/api/index.js'
export default {
  name: 'ProjectCenter',
  data () {
    return {
      imgList: [], //图标列表
      imgList2: [],
      imgList3: [],
      imgList4: [],
      type: 0,
      isActive: 0
    }
  },
  mounted () {
    this.getImgData()
  },
  methods: {
    handleImg(url) {
      window.open(url)
    },
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
    },
    changepage(index){
      if(index===0){
        this.type = 0
        this.isActive = index
      this.getImgData()
      }else if(index===1) {
         this.type = 4
        this.isActive = index
      this.getImgData()
      }else if(index===2){
         this.type = 1
        this.isActive = index
      this.getImgData()
      }else {
         this.type = 3
        this.isActive = index
      this.getImgData()
      }
      
    },
    jdxm () {
      this.type = 0     //0413
      this.isActive = 0
      this.getImgData()
      this.$refs.loop.setActiveItem(0)
    },
    zfxm () {
      this.type = 4
      this.isActive = 1
      this.getImgData()
      this.$refs.loop.setActiveItem(1)
    },
    gxxm () {
      this.type = 1
      this.isActive = 2
      this.getImgData()
      this.$refs.loop.setActiveItem(2)
    },
    xmfh () {
      this.type = 3
      this.isActive = 3
      this.getImgData()
      this.$refs.loop.setActiveItem(3)
    },

    async getImgData () {
      if (this.type === 0) {
        const res = await getImgList(this.type)
        this.imgList = res.data
      } else if (this.type === 4) {
        const res = await getImgList(this.type)
        this.imgList2 = res.data

      } else if (this.type === 1) {
        const res = await getImgList(this.type)
        this.imgList3 = res.data

      } else {
        const res = await getImgList(this.type)
        this.imgList4 = res.data
      }


    }
  }

}
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  // justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 150px;
}
.loop {
  width: 1200px;
  .loop-item {
    width: 100%;

    div {
      width: 239px;
      float: left;
      height: 126px;
      // background-color: #f4f4f4;
      border: 1px solid #eeeeee;
      margin-bottom: -1px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {

          width: 190px;
      }
    }
  }
}
.btn-box {
  width: 1200px;
  height: 70px;
  margin-top: 80px;
  margin-bottom: 50px;

  div {
    width: 180px;
    height: 60px;
    background-color: #f4f4f4;
    float: left;
    margin-right: 20px;
    text-align: center;
    line-height: 60px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    cursor: pointer;
  }
  div:hover {
    color: #1c43bd;
    // border: 2px solid #1c43bd;
  }
  div.active {
    color: #1c43bd !important;
    border: 2px solid #1c43bd !important;
  }
}
.titletext {
  width: 604px;
  height: 70px;
  // border: 1px solid #000;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 33px;
  text-align: center;
  i {
    font-style: normal;
    font-size: 32px;
    color: #f4930f;
  }
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;

  span {
    margin-top: 95px;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #1c43bd;
    margin-bottom: 30px;
  }
}
.headerbg {
  height: 580px;
  width: 100%;
  background-image: url("https://file.jycyfww.com/wangchuang/qc/prod/static/img/b1fd0e9731274635a06c6bc4661ff3c2.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  span {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    font-size: 42px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  b {
    font-size: 40px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #006cda;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Project-Center.vue